import { render, staticRenderFns } from "./PaymentProviderSelect.vue?vue&type=template&id=1de2de08&"
import script from "./PaymentProviderSelect.vue?vue&type=script&lang=js&"
export * from "./PaymentProviderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de2de08')) {
      api.createRecord('1de2de08', component.options)
    } else {
      api.reload('1de2de08', component.options)
    }
    module.hot.accept("./PaymentProviderSelect.vue?vue&type=template&id=1de2de08&", function () {
      api.rerender('1de2de08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/checkout/PaymentProviderSelect.vue"
export default component.exports